var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.icon)?_c('svg',{class:_vm.className,style:({ width: _vm.width }),attrs:{"viewBox":_vm.viewBox,"preserveAspectRatio":"none"},domProps:{"innerHTML":_vm._s(_vm.icon)}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }